<div class="list-wrapper">
    <h2>
        Moja biblioteka:
    </h2>

    <div class="list">
        <div class="list-item" *ngFor="let doc of list;">
            <div class="list-item-main">
                <div class="name">{{ doc?.name }}</div>
                <span class="type">{{ doc?.file?.extension | uppercase }}</span>
                <span class="date">Dodano: {{ getDate(doc?.createdAt) }}</span>
            </div>
            <div class="download-wrapper">
                <span class="item-icon download"
                      (click)="download(doc)"
                ></span>
            </div>
            <div class="remove-wrapper">
                <span class="item-icon"
                      (click)="removeFile(doc)"
                ></span>
            </div>
        </div>

        <div class="list-item" *ngIf="!list?.length">
            Lista jest pusta
        </div>
    </div>
</div>

